import styled from 'styled-components';

export const Title = styled.h1`
  color: ${({ theme }) => theme.dark600};
  margin-top: 0;
  margin-bottom: 2rem;
`;
